/**
*	@author Michael
*	@since  01/04/2019
**/

export class MandanteModel {

    constructor(
        public id: MchMandatariosId,
        public defCiudades: DefCiudades,
        public defTiposdocumentos: DefTiposdocumentos,
        public defTipospersona: DefTipospersona,
        public vnombre: string,
        public vapellido: string,
        public vapellido2: string,
        public vdireccion: string,
        public vnombrerut: string,
        public nporcParticipacion: number,
        public dfechaCreacion: string,
        public ccodacti : string,
        public ctarifa : string, 
        public cprefijo:DefPrefijos,
        public defTipoingreso:DefTiposIngreso
        ) { }
}
export class MchMandatariosId {

    constructor(
        public cnumcont:string,
        public ctipid:string,
        public cnumid:string,
        public ccodigoContrato:string,
        public ntipoempresa:number
    ){ }
}

export class DefCiudades{
	constructor(public id:DefCiudadesId, public vnombre:string){}
}
export class DefCiudadesId{
	constructor(public ccodigociudad:string, public ccodigodepto:string,public ccodigopais:string){}
}
export class DefTiposdocumentos{
	constructor(public ctipid:string){}
}
export class DefTipospersona{
	constructor(public ntipper:string){}
}

export class DefPrefijos{
	constructor(public cprefijo:string){}
}

export class DefTiposIngreso{
	constructor(public ntipoingreso:string){}
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Prefijo/Mandante.model.ts